import Typography from '@platform-ui-common/components/Typography/index.js';
import Color from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';
import { ReactNode } from 'react';

export interface FieldDetailProps {
  label: string;
  children: ReactNode;
  // Currently the only value supported by this prop is 2 (i.e., span across 2 columns)
  stretch?: number;
  // biome-ignore lint/complexity/useLiteralKeys: linter is wrong
  ['data-cy']?: string;
}

export default function FieldDetail({
  label,
  children,
  stretch,
  ...rest
}: FieldDetailProps): JSX.Element {
  return (
    <div className={cx('flex flex-col gap-1', { 'col-span-2': stretch === 2 })} {...rest}>
      <Typography variant="label" tag="dt" color={Color.TextSecondary}>
        {label}
      </Typography>
      <Typography variant="body" tag="dd">
        {children}
      </Typography>
    </div>
  );
}
